import request from "../../request.js";
import request2 from "../../request2.js"
import qs from "qs";
import axios from "axios";
import config from "./env.js";
// 供货商门户独立请求封装(useref头携带供货商token)
import supplierRequest from "./supplierRequest.js";

// 上次文件
export function uploadFileToYdy(data) {
  return request({
    url: "/ydy-file/uploadFileToYdy",
    method: "POST",
    data,
  });
}
// 上传文件到腾讯云-后端
export function uploadFileToTxCloudEquityFee(data) {
  return request({
    url: "/tx-cloud-file/uploadFileToTxCloudEquityFee",
    method: "POST",
    data,
  });
}
// 新增用户
export function addAjefUser(data) {
  return request({
    url: "/ajef-user/addAjefUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取腾讯云秘钥
export function getPolicyTxCloudEquityFee(data) {
  return request({
    url: "/tx-cloud-file/getPolicyTxCloudEquityFee",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取用户列表
export function getAjefUserList(data) {
  return request({
    url: "/ajef-user/getAjefUserList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑用户
export function updateAjefUser(data) {
  return request({
    url: "/ajef-user/updateAjefUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 登录
export function doLogin(data) {
  return request({
    url: "/ajef-user/doLogin",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除用户
export function deleteAjefUser(data) {
  return request({
    url: "/ajef-user/deleteAjefUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增商户
export function addAjefShop(data) {
  return request({
    url: "/ajef-shop/addAjefShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除商户
export function deleteAjefShop(data) {
  return request({
    url: "/ajef-shop/deleteAjefShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户
export function getAjefShopList(data) {
  return request({
    url: "/ajef-shop/getAjefShopList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户
export function getAjefShopListQuick(data) {
  return request({
    url: "/ajef-shop/getAjefShopListQuick",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 欠款商户列表：读欠款快照表（定时任务每小时自动刷新），欠款=撤销账单+发票补差+平台垫资提现+商城订单分账退款；
// 入参 asStatus/asName(模糊)/asNumber(模糊)/ascId/ascdId/分页，返回行含元展示字段（*Yuan）与商户信息
export function getAjefShopDebtList(data) {
  return request({
    url: "/ajef-shop/getAjefShopDebtList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 手动刷新欠款快照（列表页刷新按钮用，无参），返回刷新后的欠款商户数
export function updateAjefShopDebtRefresh() {
  return request({
    url: "/ajef-shop/updateAjefShopDebtRefresh",
    method: "POST",
    data: {},
  });
}
// 商户充值-线下收款(欠款清账)：线下收到商户打款后录入(asId必填/rechargeMoney元必填≥1/rechargeDes凭证说明≤500字)；
// 充值入账并生成收入账单，余额覆盖欠款时同事务自动结清(返回 rechargeMoneyYuan/settled/settledMoneyYuan/debtRemaining/rechargeBillId)
export function addAjefShopRecharge(data) {
  return request({
    url: "/ajef-shop/addAjefShopRecharge",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户-详情
export function getAjefShopDetails(data) {
  return request({
    url: "/ajef-shop/getAjefShopDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户-编辑
export function updateAjefShop(data) {
  return request({
    url: "/ajef-shop/updateAjefShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户信息校验-批量OCR识别校验(asIds逗号分隔;后端逐个同步识别,每个约2~10秒,商户越多等待越久;
// 裸axios长超时:默认120s不够多商户批量,返回逐商户结果列表{asId,asName,asNumber,status,statusMsg})
export function updateAjefShopInfoCheck(data) {
  return axios({
    method: "post",
    url: config.baseURL + "/ajef-shop/updateAjefShopInfoCheck",
    data: qs.stringify(data),
    timeout: 1200000,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      useref: window.localStorage.getItem("Qy_token"),
    },
  }).then((res) => res.data);
}
// 商户信息校验-人工处理(OCR误判时人工纠正校验状态;仅允许 asStatusInfoCheck=2一致/3不一致)
export function updateAjefShopInfoCheckManual(data) {
  return request({
    url: "/ajef-shop/updateAjefShopInfoCheckManual",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑商户排序
export function updateAjefShopOrder(data) {
  return request({
    url: "/ajef-shop/updateAjefShopOrder",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户账单
export function getAjefShopBillList(data) {
  return request({
    url: "/ajef-shop-bill/getAjefShopBillList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批量生成卷
export function addAjefCertificateRecordMulti(data) {
  return request({
    url: "/ajef-certificate-record/addAjefCertificateRecordMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批量撤销卷
export function cancelAjefCertificateRecordMulti(data) {
  return request({
    url: "/ajef-certificate-record/cancelAjefCertificateRecordMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码对账核查-处理失败的进行处理（更新核查状态与描述）
export function updateAjefCertificateRecordCopyCheckDes(data) {
  return request({
    url: "/ajef-certificate-statistics-check/updateAjefCertificateRecordCopyCheckDes",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码对账核查-查询关联的订单和账单（返回列表）
export function getAjefCertificateRecordCopyCheckOrderBill(data) {
  return request({
    url: "/ajef-certificate-statistics-check/getAjefCertificateRecordCopyCheckOrderBill",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码对账核查-添加账单
export function addAjefCertificateRecordCopyCheckBill(data) {
  return request({
    url: "/ajef-certificate-statistics-check/addAjefCertificateRecordCopyCheckBill",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码对账核查-扣减权益金
export function addAjefCertificateRecordCopyCheckOrder(data) {
  return request({
    url: "/ajef-certificate-statistics-check/addAjefCertificateRecordCopyCheckOrder",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码对账核查-添加订单记录
export function addAjefCertificateRecordCopyCheckOrderRecord(data) {
  return request({
    url: "/ajef-certificate-statistics-check/addAjefCertificateRecordCopyCheckOrderRecord",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询卷记录
export function getAjefCertificateRecordList(data) {
  return request({
    url: "/ajef-certificate-record/getAjefCertificateRecordList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码规格-查询列表
export function getAjefCertificateRecordSpecsList(data) {
  return request({
    url: "/ajef-certificate-record-specs/getAjefCertificateRecordSpecsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码规格-新增
export function addAjefCertificateRecordSpecs(data) {
  return request({
    url: "/ajef-certificate-record-specs/addAjefCertificateRecordSpecs",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码规格-编辑
export function updateAjefCertificateRecordSpecs(data) {
  return request({
    url: "/ajef-certificate-record-specs/updateAjefCertificateRecordSpecs",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码规格-删除
export function deleteAjefCertificateRecordSpecs(data) {
  return request({
    url: "/ajef-certificate-record-specs/deleteAjefCertificateRecordSpecs",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码查看记录-查询列表
export function getAjefCertificateRecordLookList(data) {
  return request({
    url: "/ajef-certificate-record-look/getAjefCertificateRecordLookList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券记录未领取-查询列表
export function getAjefCertificateRecordSubList(data) {
  return request({
    url: "/ajef-certificate-record-sub/getAjefCertificateRecordSubList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券记录未领取-退款
export function updateAjefCertificateRecordSubRefund(data) {
  return request({
    url: "/ajef-certificate-record-sub/updateAjefCertificateRecordSubRefund",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增商户管理员
export function addAjefUserShopAdmin(data) {
  return request({
    url: "/ajef-user-shop/addAjefUserShopAdmin",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增商户核销员
export function addAjefUserShopUser(data) {
  return request({
    url: "/ajef-user-shop/addAjefUserShopUser",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 删除商户用户
export function deleteAjefUserShop(data) {
  return request({
    url: "/ajef-user-shop/deleteAjefUserShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户用户
export function getAjefUserShopList(data) {
  return request({
    url: "/ajef-user-shop/getAjefUserShopList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑商户用户
export function updateAjefUserShop(data) {
  return request({
    url: "/ajef-user-shop/updateAjefUserShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户账单新
export function getAjefShopBillListp(data) {
  return request({
    url: "/ajef-shop-bill/getAjefShopBillListp",
    method: "POST",
    data: qs.stringify(data),
  });
}
//提现申请
export function getAjefApplyWithdrawList(data) {
  return request({
    url: "/ajef-apply-withdraw/getAjefApplyWithdrawList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//微信账单回调
export function getWxPayNotifyList(data) {
  return request({
    url: "/wx-pay-notify/getWxPayNotifyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-新增发票通知
export function addAjefShopReceipt(data) {
  return request({
    url: "/ajef-shop-receipt/addAjefShopReceipt",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-发票通知
export function getAjefShopReceiptList(data) {
  return request({
    url: "/ajef-shop-receipt/getAjefShopReceiptList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-发票审核
export function updateAjefShopReceiptStatusCheck(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceiptStatusCheck",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-驳回
export function updateAjefShopReceiptStatusCheckRevoke(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceiptStatusCheckRevoke",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-发票通知
export function updateAjefShopReceiptStatusSend(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceiptStatusSend",
    method: "POST",
    data: qs.stringify(data),
  });
}
//对公打款编辑账单信息
export function updateAjefApplyWithdrawPayment(data) {
  return request({
    url: "/ajef-apply-withdraw/updateAjefApplyWithdrawPayment",
    method: "POST",
    data: qs.stringify(data),
  });
}
//用户修改密码
export function updateAjefUserPw(data) {
  return request({
    url: "/ajef-user/updateAjefUserPw",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户审核-通过
export function updateAjefShopCheckPass(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCheckPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户审核-不通过
export function updateAjefShopCheckNotPass(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCheckNotPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户账单-详情
export function getAjefShopBillDetails(data) {
  return request({
    url: "/ajef-shop-bill/getAjefShopBillDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户开票结算类型
export function getAjefShopReceiptTypeList(data) {
  return request({
    url: "/ajef-shop-receipt-type/getAjefShopReceiptTypeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//系统日志
export function getSysLogList(data) {
  return request({
    url: "/sys-log/getSysLogList",
    method: "POST",
    data,
  });
}
//新增银行卡可选范围
export function addAjefShopBankOptinons(data) {
  return request({
    url: "/ajef-shop-bank-optinons/addAjefShopBankOptinons",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑银行可选范围
export function updateAjefShopBankOptinons(data) {
  return request({
    url: "/ajef-shop-bank-optinons/updateAjefShopBankOptinons",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除银行可选范围
export function deleteAjefShopBankOptinons(data) {
  return request({
    url: "/ajef-shop-bank-optinons/deleteAjefShopBankOptinons",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取银行可选范围
export function getAjefShopBankOptinonsList(data) {
  return request({
    url: "/ajef-shop-bank-optinons/getAjefShopBankOptinonsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户用户列表
export function getAjefUserShopBindList(data) {
  return request({
    url: "/ajef-user-shop-bind/getAjefUserShopBindList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//查询地区
export function getSysRegionList(data) {
  return request({
    url: "/sys-region/getSysRegionList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户充值奖励请
export function updateAjefShopCheckPassGift(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCheckPassGift",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增地区信息
export function addSysRegion(data) {
  return request({
    url: "/sys-region/addSysRegion",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑地区信息
export function updateSysRegion(data) {
  return request({
    url: "/sys-region/updateSysRegion",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除地区信息
export function deleteSysRegion(data) {
  return request({
    url: "/sys-region/deleteSysRegion",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取权限列表
export function getAjefAuthList(data) {
  return request({
    url: "/ajef-auth/getAjefAuthList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增权限列表
export function addAjefAuth(data) {
  return request({
    url: "/ajef-auth/addAjefAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除权限列表
export function deleteAjefAuth(data) {
  return request({
    url: "/ajef-auth/deleteAjefAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑权限列表
export function updateAjefAuth(data) {
  return request({
    url: "/ajef-auth/updateAjefAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取树权限列表
export function getAjefAuthTree(data) {
  return request({
    url: "/ajef-auth/getAjefAuthTree",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新建角色
export function addAjefRole(data) {
  return request({
    url: "/ajef-role/addAjefRole",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除角色
export function deleteAjefRole(data) {
  return request({
    url: "/ajef-role/deleteAjefRole",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取角色权限
export function getAjefRoleAuthList(data) {
  return request({
    url: "/ajef-role/getAjefRoleAuthList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取角色列表
export function getAjefRoleList(data) {
  return request({
    url: "/ajef-role/getAjefRoleList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑角色列表
export function updateAjefRole(data) {
  return request({
    url: "/ajef-role/updateAjefRole",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑角色权限
export function updateAjefRoleAuth(data) {
  return request({
    url: "/ajef-role/updateAjefRoleAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//开票结算类型审核列表
export function getAjefShopReceiptTypeChangeApplyList(data) {
  return request({
    url: "/ajef-shop-receipt-type-change-apply/getAjefShopReceiptTypeChangeApplyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//开票结算类型审核-不通过
export function updateAjefShopReceiptTypeCheckNotPass(data) {
  return request({
    url: "/ajef-shop-receipt-type-change-apply/updateAjefShopReceiptTypeCheckNotPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//开票结算类型审核-通过
export function updateAjefShopReceiptTypeCheckPass(data) {
  return request({
    url: "/ajef-shop-receipt-type-change-apply/updateAjefShopReceiptTypeCheckPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//卡劵规格-新增
export function addAjefCertificateRecordRelationXiaoxiang(data) {
  return request({
    url: "/ajef-certificate-record-relation-xiaoxiang/addAjefCertificateRecordRelationXiaoxiang",
    method: "POST",
    data: qs.stringify(data),
  });
}
//卡劵规格-编辑
export function updateAjefCertificateRecordRelationXiaoxiang(data) {
  return request({
    url: "/ajef-certificate-record-relation-xiaoxiang/updateAjefCertificateRecordRelationXiaoxiang",
    method: "POST",
    data: qs.stringify(data),
  });
}
//卡劵规格-编辑
export function getAjefCertificateRecordRelationXiaoxiangList(data) {
  return request({
    url: "/ajef-certificate-record-relation-xiaoxiang/getAjefCertificateRecordRelationXiaoxiangList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//卡劵规格-删除
export function deleteAjefCertificateRecordRelationXiaoxiang(data) {
  return request({
    url: "/ajef-certificate-record-relation-xiaoxiang/deleteAjefCertificateRecordRelationXiaoxiang",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增移动公司存量客户
export function addAjefShopStockYidong(data) {
  return request({
    url: "/ajef-shop-stock-yidong/addAjefShopStockYidong",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑移动公司存量客户
export function updateAjefShopStockYidong(data) {
  return request({
    url: "/ajef-shop-stock-yidong/updateAjefShopStockYidong",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除移动公司存量客户
export function deleteAjefShopStockYidong(data) {
  return request({
    url: "/ajef-shop-stock-yidong/deleteAjefShopStockYidong",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取移动公司存量客户
export function getAjefShopStockYidongList(data) {
  return request({
    url: "/ajef-shop-stock-yidong/getAjefShopStockYidongList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//批量导入移动公司存量客户
export function uploadAjefShopStockYidong(data) {
  return request({
    url: "/ajef-shop-stock-yidong/uploadAjefShopStockYidong",
    method: "POST",
    data,
  });
}
//主页获取用户权限
export function getAjefUserDetailsRefresh(data) {
  return request({
    url: "/ajef-user/getAjefUserDetailsRefresh",
    method: "POST",
    data: qs.stringify(data),
  });
}
//主页获取用户所有通知
export function getAjefUserNoticeTotal(data) {
  return request({
    url: "/ajef-user/getAjefUserNoticeTotal",
    method: "POST",
    data: qs.stringify(data),
  });
}
//主页获取用户所有通知数量
export function getAjefUserNoticeTotalNum(data) {
  return request({
    url: "/ajef-user/getAjefUserNoticeTotalNum",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户审核查询
export function updateAjefShopCheckBefore(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCheckBefore",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增商品兑换收集
export function addAjefShopCollectionGoods(data) {
  return request({
    url: "/ajef-shop-collection-goods/addAjefShopCollectionGoods",
    method: "POST",
    data: qs.stringify(data),
  });
}
//查询商品兑换收集
export function getAjefShopCollectionGoodsList(data) {
  return request({
    url: "/ajef-shop-collection-goods/getAjefShopCollectionGoodsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑商品兑换收集
export function updateAjefShopCollectionGoods(data) {
  return request({
    url: "/ajef-shop-collection-goods/updateAjefShopCollectionGoods",
    method: "POST",
    data: qs.stringify(data),
  });
}
//暂停商品兑换收集
export function updateAjefShopCollectionGoodsDown(data) {
  return request({
    url: "/ajef-shop-collection-goods/updateAjefShopCollectionGoodsDown",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发布商品兑换收集
export function updateAjefShopCollectionGoodsUp(data) {
  return request({
    url: "/ajef-shop-collection-goods/updateAjefShopCollectionGoodsUp",
    method: "POST",
    data: qs.stringify(data),
  });
}
//查询商户上传商品兑换收集
export function getAjefShopCollectionGoodsRecordList(data) {
  return request({
    url: "/ajef-shop-collection-goods-record/getAjefShopCollectionGoodsRecordList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除商户上传商品兑换收集
export function deleteAjefShopCollectionGoodsRecord(data) {
  return request({
    url: "/ajef-shop-collection-goods-record/deleteAjefShopCollectionGoodsRecord",
    method: "POST",
    data: qs.stringify(data),
  });
}
//地市权限查询核销账单
export function getAjefShopBillListCustomer(data) {
  return request({
    url: "/certificate_record-customer/getAjefShopBillListCustomer",
    method: "POST",
    data: qs.stringify(data),
  });
}
//地市权限查询商户
export function getAjefShopListCustomer(data) {
  return request({
    url: "/certificate_record-customer/getAjefShopListCustomer",
    method: "POST",
    data: qs.stringify(data),
  });
}
//查询商户地市
export function getAjefShopCityList(data) {
  return request({
    url: "/ajef-shop-city/getAjefShopCityList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//查询商户区县
export function getAjefShopCityDistrictList(data) {
  return request({
    url: "/ajef-shop-city-district/getAjefShopCityDistrictList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑商户区县
export function updateAjefShopCityDistrict(data) {
  return request({
    url: "/ajef-shop-city-district/updateAjefShopCityDistrict",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑商户地市
export function updateAjefShopCity(data) {
  return request({
    url: "/ajef-shop-city/updateAjefShopCity",
    method: "POST",
    data: qs.stringify(data),
  });
}
//账单-退款申请
export function getAjefShopBillRevokeList(data) {
  return request({
    url: "/ajef-shop-bill-revoke/getAjefShopBillRevokeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//账单-退款申请-处理
export function updateAjefShopBillRevokeHandler(data) {
  return request({
    url: "/ajef-shop-bill-revoke/updateAjefShopBillRevokeHandler",
    method: "POST",
    data: qs.stringify(data),
  });
}
//账单-退款申请-处理退款-同步退权益金
export function updateAjefShopBillRevokeHandlerYd(data) {
  return request({
    url: "/ajef-shop-bill-revoke/updateAjefShopBillRevokeHandlerYd",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑关键值
export function updateSysOurageKey(data) {
  return request({
    url: "/sys-ourage-key/updateSysOurageKey",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑关键值
export function getSysOurageKeyList(data) {
  return request({
    url: "/sys-ourage-key/getSysOurageKeyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//批量导入已入账发票信息
export function uploadAjefShopReceiptInBill(data) {
  return request({
    url: "/ajef-shop-receipt/uploadAjefShopReceiptInBill",
    method: "POST",
    data,
  });
}
//财务统计 -总的
export function getAjefCertificateRecordStatisticsYear(data) {
  return request({
    url: "/ajef-certificate-record-statistics/getAjefCertificateRecordStatisticsYear",
    method: "POST",
    data: qs.stringify(data),
  });
}
//财务统计 -商户总的
export function getAjefCertificateRecordStatisticsYearShop(data) {
  return request({
    url: "/ajef-certificate-record-statistics/getAjefCertificateRecordStatisticsYearShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通知-查询
export function getSysNoticeList(data) {
  return request({
    url: "/sys-notice/getSysNoticeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通知-删除
export function deleteSysNoticeRead(data) {
  return request({
    url: "/sys-notice/deleteSysNoticeRead",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通知-分类标题
export function getSysNoticeListTitle(data) {
  return request({
    url: "/sys-notice/getSysNoticeListTitle",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通知-已读
export function updateSysNoticeRead(data) {
  return request({
    url: "/sys-notice/updateSysNoticeRead",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通知-未通知数量
export function getSysNoticeUnReadNum(data) {
  return request({
    url: "/sys-notice/getSysNoticeUnReadNum",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通知-一键已读
export function updateSysNoticeReadAll(data) {
  return request({
    url: "/sys-notice/updateSysNoticeReadAll",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通告-新增
export function addSysBulletin(data) {
  return request({
    url: "/sys-bulletin/addSysBulletin",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通告-查询
export function getSysBulletinList(data) {
  return request({
    url: "/sys-bulletin/getSysBulletinList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通告-编辑
export function updateSysBulletin(data) {
  return request({
    url: "/sys-bulletin/updateSysBulletin",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通告-下架
export function updateSysBulletinDown(data) {
  return request({
    url: "/sys-bulletin/updateSysBulletinDown",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通告-上架
export function updateSysBulletinUp(data) {
  return request({
    url: "/sys-bulletin/updateSysBulletinUp",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通告-查询阅读记录
export function getSysBulletinReadList(data) {
  return request({
    url: "/sys-bulletin-read/getSysBulletinReadList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//核销明细-查询列表
export function getAjefCertificateStatisticsCheckList(data) {
  return request({
    url: "/ajef-certificate-statistics-check/getAjefCertificateStatisticsCheckList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//核销明细-查询列表
export function getAjefCertificateStatisticsCheckListCustomer(data) {
  return request({
    url: "/certificate_record-customer/getAjefCertificateStatisticsCheckListCustomer",
    method: "POST",
    data: qs.stringify(data),
  });
}
//财务统计-充值记录新增
export function addAjefApplyRecharge(data) {
  return request({
    url: "/ajef-apply-recharge/addAjefApplyRecharge",
    method: "POST",
    data: qs.stringify(data),
  });
}
//财务统计-充值记录编辑
export function updateAjefApplyRecharge(data) {
  return request({
    url: "/ajef-apply-recharge/updateAjefApplyRecharge",
    method: "POST",
    data: qs.stringify(data),
  });
}
//财务统计-充值记录查询
export function getAjefApplyRechargeList(data) {
  return request({
    url: "/ajef-apply-recharge/getAjefApplyRechargeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//财务统计-充值记录查询
export function getAjefApplyRechargeRemaining(data) {
  return request({
    url: "/ajef-apply-recharge/getAjefApplyRechargeRemaining",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-商户复核-新增
export function addAjefShopAgain(data) {
  return request({
    url: "/ajef-shop-again/addAjefShopAgain",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-商户复核-审核不通过
export function updateAjefShopAgainNotPass(data) {
  return request({
    url: "/ajef-shop-again/updateAjefShopAgainNotPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-商户复核-审核通过
export function updateAjefShopAgainPass(data) {
  return request({
    url: "/ajef-shop-again/updateAjefShopAgainPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-商户复核-列表
export function getAjefShopAgainList(data) {
  return request({
    url: "/ajef-shop-again/getAjefShopAgainList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-里程碑
export function getAjefShopMilestoneList(data) {
  return request({
    url: "/ajef-shop-milestone/getAjefShopMilestoneList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-修改商户类型
export function updateAjefShopTypeShop(data) {
  return request({
    url: "/ajef-shop/updateAjefShopTypeShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-修改分账类型
export function updateAjefShopBillShareTypeShop(data) {
  return request({
    url: "/ajef-shop/updateAjefShopBillShareTypeShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票 - 发票补差价记录列表
export function getAjefShopBillDifferenceReceiptList(data) {
  return request({
    url: "/ajef-shop-bill-difference-receipt/getAjefShopBillDifferenceReceiptList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票 - 发票补差价记录新增
export function addAjefShopBillDifferenceReceipt(data) {
  return request({
    url: "/ajef-shop-bill-difference-receipt/addAjefShopBillDifferenceReceipt",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票 - 发票补差价记录取消
export function updateAjefShopBillDifferenceReceiptCancel(data) {
  return request({
    url: "/ajef-shop-bill-difference-receipt/updateAjefShopBillDifferenceReceiptCancel",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票 - 发票补差价记录处理
export function updateAjefShopBillDifferenceReceiptHandler(data) {
  return request({
    url: "/ajef-shop-bill-difference-receipt/updateAjefShopBillDifferenceReceiptHandler",
    method: "POST",
    data: qs.stringify(data),
  });
}
//日志-活跃统计
export function getSysLogStatisticsList(data) {
  return request({
    url: "/sys-log-statistics/getSysLogStatisticsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//日志-活跃统计时间段
export function getSysLogStatisticsDetails(data) {
  return request({
    url: "/sys-log-statistics/getSysLogStatisticsDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
//账单-退款
export function updateAjefShopBillShopRevokeAdmin(data) {
  return request({
    url: "/ajef-shop-bill-revoke/updateAjefShopBillShopRevokeAdmin",
    method: "POST",
    data: qs.stringify(data),
  });
}
//账单-驳回退款
export function updateAjefShopBillRevokeHandlerReject(data) {
  return request({
    url: "/ajef-shop-bill-revoke/updateAjefShopBillRevokeHandlerReject",
    method: "POST",
    data: qs.stringify(data),
  });
}
//禁用商户
export function updateAjefShopDisable(data) {
  return request({
    url: "/ajef-shop/updateAjefShopDisable",
    method: "POST",
    data: qs.stringify(data),
  });
}
//解禁商户
export function updateAjefShopEnable(data) {
  return request({
    url: "/ajef-shop/updateAjefShopEnable",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户-禁用核销
export function updateAjefShopDisableHeXiao(data) {
  return request({
    url: "/ajef-shop/updateAjefShopDisableHeXiao",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户-解禁核销
export function updateAjefShopEnableHeXiao(data) {
  return request({
    url: "/ajef-shop/updateAjefShopEnableHeXiao",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户-批量禁用核销
export function updateAjefShopDisableHeXiaoMulti(data) {
  return request({
    url: "/ajef-shop/updateAjefShopDisableHeXiaoMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户-批量解禁核销
export function updateAjefShopEnableHeXiaoMulti(data) {
  return request({
    url: "/ajef-shop/updateAjefShopEnableHeXiaoMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//提现记录-编辑对公打款
export function updateAjefApplyWithdrawPaymentDes(data) {
  return request({
    url: "/ajef-apply-withdraw/updateAjefApplyWithdrawPaymentDes",
    method: "POST",
    data: qs.stringify(data),
  });
}
//提现-对公打款-系统管理员
export function addAjefApplyWithdrawPublicSys(data) {
  return request({
    url: "/ajef-apply-withdraw/addAjefApplyWithdrawPublicSys",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户-对公信息校验
export function updateAjefShopBankCheck(data) {
  return request({
    url: "/ajef-shop/updateAjefShopBankCheck",
    method: "POST",
    data: qs.stringify(data),
  });
}
//特殊卡劵-附加信息核销记录
export function getAjefCertificateRecordExpandDetectorList(data) {
  return request({
    url: "/ajef-certificate-record-expand-detector/getAjefCertificateRecordExpandDetectorList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//特殊卡劵-重新同步
export function updateAjefCertificateRecordExpandDetectorUserState(data) {
  return request({
    url: "/ajef-certificate-record-expand-detector/updateAjefCertificateRecordExpandDetectorUserState",
    method: "POST",
    data: qs.stringify(data),
  });
}
//提现申请 - 批量处理对公打款
export function updateAjefApplyWithdrawPaymentMulti(data) {
  return request({
    url: "/ajef-apply-withdraw/updateAjefApplyWithdrawPaymentMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//提现申请 - 批量编辑对公打款
export function updateAjefApplyWithdrawPaymentDesMulti(data) {
  return request({
    url: "/ajef-apply-withdraw/updateAjefApplyWithdrawPaymentDesMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//系统对公提现申请记录 - 新增记录
export function addAjefApplyWithdrawAdvanceSys(data) {
  return request({
    url: "/ajef-apply-withdraw-advance-sys/addAjefApplyWithdrawAdvanceSys",
    method: "POST",
    data: qs.stringify(data),
  });
}
//系统对公提现申请记录 - 记录
export function getAjefApplyWithdrawAdvanceSysList(data) {
  return request({
    url: "/ajef-apply-withdraw-advance-sys/getAjefApplyWithdrawAdvanceSysList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//系统对公提现申请记录 - 取消记录
export function updateAjefApplyWithdrawAdvanceSysCancel(data) {
  return request({
    url: "/ajef-apply-withdraw-advance-sys/updateAjefApplyWithdrawAdvanceSysCancel",
    method: "POST",
    data: qs.stringify(data),
  });
}
//系统对公提现申请记录 - 通过发送
export function updateAjefApplyWithdrawAdvanceSysSend(data) {
  return request({
    url: "/ajef-apply-withdraw-advance-sys/updateAjefApplyWithdrawAdvanceSysSend",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户发票记录-其他信息
export function updateAjefShopReceipt(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceipt",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户发票记录-批量修改处理时间
export function updateAjefShopReceiptStatusCheckMulti(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceiptStatusCheckMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//存量日志
export function getSysLogCopyList(data) {
  return request({
    url: "/sys-log-copy/getSysLogCopyList",
    method: "POST",
    data
  });
}
//存量日志-复制日志
export function updateSysLogCopyDo(data) {
  return request({
    url: "/sys-log-copy/updateSysLogCopyDo",
    method: "POST",
    data: qs.stringify(data),
  });
}
//小象领取记录-导出
export function exportAjefCertificateRecordXiaoxiang(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang/exportAjefCertificateRecordXiaoxiang",
    method: "POST",
    data: qs.stringify(data),
  });
}
//小象领取记录
export function getAjefCertificateRecordXiaoxiangList(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang/getAjefCertificateRecordXiaoxiangList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//小象领取记录-导入小象兑换券记录
export function uploadAjefCertificateRecordXiaoxiangOne(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang/uploadAjefCertificateRecordXiaoxiangOne",
    method: "POST",
    data
  });
}
//小象领取记录-导入小象兑换券记录关联劵码
export function uploadAjefCertificateRecordXiaoxiangTwo(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang/uploadAjefCertificateRecordXiaoxiangTwo",
    method: "POST",
    data
  });
}
//小象领取记录-统计
export function getAjefCertificateRecordXiaoxiangStatisticsList(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang-statistics/getAjefCertificateRecordXiaoxiangStatisticsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//小象领取记录-重新计算
export function getAjefCertificateRecordXiaoxiangStatisticsSumAgain(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang-statistics/getAjefCertificateRecordXiaoxiangStatisticsSumAgain",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户通告列表-上传商户获取id
export function uploadShopReturnAsIdsList(data) {
  return request({
    url: "/sys-bulletin/uploadShopReturnAsIdsList",
    method: "POST",
    data,
  });
}
//发票管理-平台上传发票
export function updateAjefShopReceiptFiles(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceiptFiles",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票明细统计-记录
export function getAjefCertificateRecordXiaoxiangReceiptList(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang-receipt/getAjefCertificateRecordXiaoxiangReceiptList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票明细统计-执行
export function updateAjefCertificateRecordXiaoxiangReceiptHandler(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang-receipt/updateAjefCertificateRecordXiaoxiangReceiptHandler",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金操作错误记录
export function getAjefRightsFundErrorList(data) {
  return request2({
    url: "/ajef-rights-fund-error/getAjefRightsFundErrorList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金操作记录详情
export function getAjefRightsFundBillDetails(data) {
  return request2({
    url: "/ajef-rights-fund-bill/getAjefRightsFundBillDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金操作记录
export function getAjefRightsFundBillList(data) {
  return request2({
    url: "/ajef-rights-fund-bill/getAjefRightsFundBillList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金回退记录
export function getAjefRightsFundRollbackList(data) {
  return request2({
    url: "/ajef-rights-fund-rollback/getAjefRightsFundRollbackList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金扣减记录
export function getAjefRightsFundDeductList(data) {
  return request2({
    url: "/ajef-rights-fund-deduct/getAjefRightsFundDeductList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金扣减记录-系统操作回退
export function updateAjefRightsFundDeductRollback(data) {
  return request2({
    url: "/ajef-rights-fund-deduct/updateAjefRightsFundDeductRollback",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金扣减记录-补建(按移动流水,移动已扣款但记录丢失的处置入口)
export function updateAjefRightsFundDeductRecover(data) {
  return request2({
    url: "/ajef-rights-fund-deduct/updateAjefRightsFundDeductRecover",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金操作日志-Two
export function getSysLogListTwo(data) {
  return request2({
    url: "/sys-log/getSysLogList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金日志活跃统计-Two
export function getSysLogStatisticsListTwo(data) {
  return request2({
    url: "/sys-log-statistics/getSysLogStatisticsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金日志活跃统计时间段-Two
export function getSysLogStatisticsDetailsTwo(data) {
  return request2({
    url: "/sys-log-statistics/getSysLogStatisticsDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金操作日志复制迁移-Two
export function getSysLogCopyListTwo(data) {
  return request2({
    url: "/sys-log-copy/getSysLogCopyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金操作日志-复制迁移执行-Two
export function updateSysLogCopyDoTwo(data) {
  return request2({
    url: "/sys-log-copy/updateSysLogCopyDo",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 黑名单相关 ====================
// 新建黑名单
export function addSysBlacklist(data) {
  return request({
    url: "/sys-blacklist/addSysBlacklist",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除黑名单
export function deleteSysBlacklist(data) {
  return request({
    url: "/sys-blacklist/deleteSysBlacklist",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询黑名单
export function getSysBlacklistList(data) {
  return request({
    url: "/sys-blacklist/getSysBlacklistList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询黑名单手机号集合
export function getSysBlacklistListQuick(data) {
  return request({
    url: "/sys-blacklist/getSysBlacklistListQuick",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑黑名单
export function updateSysBlacklist(data) {
  return request({
    url: "/sys-blacklist/updateSysBlacklist",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 北国超市订单记录 ====================
// 北国超市订单记录
export function getAjefBillBeiguoList(data) {
  return request({
    url: "/ajef-bill-beiguo/getAjefBillBeiguoList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 北国超市订单-退款
export function updateAjefBillBeiguoRefund(data) {
  return request({
    url: "/ajef-bill-beiguo/updateAjefBillBeiguoRefund",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 北国超市订单-状态核查
export function getAjefBillBeiguoOneCheck(data) {
  return request({
    url: "/ajef-bill-beiguo/getAjefBillBeiguoOneCheck",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 北国券码规格 ====================
// 北国券码规格列表
export function getAjefCertificateRecordSpecsBeiguoList(data) {
  return request({
    url: "/ajef-certificate-record-specs-beiguo/getAjefCertificateRecordSpecsBeiguoList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增北国券码规格
export function addAjefCertificateRecordSpecsBeiguo(data) {
  return request({
    url: "/ajef-certificate-record-specs-beiguo/addAjefCertificateRecordSpecsBeiguo",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑北国券码规格
export function updateAjefCertificateRecordSpecsBeiguo(data) {
  return request({
    url: "/ajef-certificate-record-specs-beiguo/updateAjefCertificateRecordSpecsBeiguo",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除北国券码规格
export function deleteAjefCertificateRecordSpecsBeiguo(data) {
  return request({
    url: "/ajef-certificate-record-specs-beiguo/deleteAjefCertificateRecordSpecsBeiguo",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 商户规格关联 ====================
// 商户规格关联
export function addOrUpdateAjefCertificateRecordSpecsRelationShop(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/addOrUpdateAjefCertificateRecordSpecsRelationShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询商户商品规格详情
export function getAjefShopDetailsGoodsSpecs(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/getAjefShopDetailsGoodsSpecs",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户规格关联-上架
export function updateAjefCertificateRecordSpecsRelationShopUp(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/updateAjefCertificateRecordSpecsRelationShopUp",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户规格关联-下架
export function updateAjefCertificateRecordSpecsRelationShopDown(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/updateAjefCertificateRecordSpecsRelationShopDown",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户规格关联-审核
export function updateAjefCertificateRecordSpecsRelationShopCheck(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/updateAjefCertificateRecordSpecsRelationShopCheck",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户规格关联-列表查询
export function getAjefCertificateRecordSpecsRelationShopList(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/getAjefCertificateRecordSpecsRelationShopList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户规格关联-导出excel
export function exportAjefCertificateRecordSpecsRelationShop(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/exportAjefCertificateRecordSpecsRelationShop",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 北国券码使用通知 ====================
// 北国券码使用通知
export function getBillBeiguoNotifyList(data) {
  return request({
    url: "/billBeiguoNotify/getBillBeiguoNotifyList",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 商户类型 ====================
// 商户类型-列表查询
export function getAjefShopTypeList(data) {
  return request({
    url: "/ajef-shop-type/getAjefShopTypeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户类型-编辑
export function updateAjefShopType(data) {
  return request({
    url: "/ajef-shop-type/updateAjefShopType",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 分账类型-获取列表
export function getAjefShopBillShareTypeList(data) {
  return request({
    url: "/ajef-shop/getAjefShopBillShareTypeList",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 编辑商户地市和名称
export function updateAjefShopCityAndName(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCityAndName",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 权益金余额查询 ====================
// 权益金余额查询-查询余额
export function getYdApiBalanceData(data) {
  return request2({
    url: "/ydApi/getYdApiBalanceData",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 权益金余额查询-查询流水记录
export function getYdApiBalanceRecordList(data) {
  return request2({
    url: "/ydApi/getYdApiBalanceRecordList",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 全量商品(报备移动商品记录) ====================
// 全量商品-列表查询
export function getAjefGoodsYdList(data) {
  return request({
    url: "/ajef-goods-yd/getAjefGoodsYdList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 全量商品-新增
export function addAjefGoodsYd(data) {
  return request({
    url: "/ajef-goods-yd/addAjefGoodsYd",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 全量商品-编辑
export function updateAjefGoodsYd(data) {
  return request({
    url: "/ajef-goods-yd/updateAjefGoodsYd",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 全量商品-删除
export function deleteAjefGoodsYd(data) {
  return request({
    url: "/ajef-goods-yd/deleteAjefGoodsYd",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 短信注册记录 ====================
// 短信注册记录-列表查询
export function getSysRegisterCodeList(data) {
  return request({
    url: "/sys-register-code/getSysRegisterCodeList",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 全量扣减记录(订单记录) ====================
// 权益金扣减记录(订单记录)-列表查询
export function getAjefRightsFundDeductCopyList(data) {
  return request({
    url: "/ajef-rights-fund-deduct-copy/getAjefRightsFundDeductCopyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 权益金扣减记录-运营描述
export function updateAjefRightsFundDeductCopyHandlerOperation(data) {
  return request({
    url: "/ajef-rights-fund-deduct-copy/updateAjefRightsFundDeductCopyHandlerOperation",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 全量回退记录(退款记录) ====================
// 权益金回退记录(退款记录)-列表查询
export function getAjefRightsFundRollbackCopyList(data) {
  return request({
    url: "/ajef-rights-fund-rollback-copy/getAjefRightsFundRollbackCopyList",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 易宝通订单相关 ====================
// 易宝通订单-列表查询
export function getYbtPayOrderList(data) {
  return request2({
    url: "/ybt-pay-order/getYbtPayOrderList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 易宝通订单-详情查询
export function getYbtPayOrderDetails(data) {
  return request2({
    url: "/ybt-pay-order/getYbtPayOrderDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 易宝通异步通知记录-列表查询
export function getYbtPayOrderNotifyList(data) {
  return request2({
    url: "/ybt-pay-order-notify/getYbtPayOrderNotifyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 支付接口响应结果-列表查询
export function getYbtPayOrderResponseList(data) {
  return request2({
    url: "/ybt-pay-order-response/getYbtPayOrderResponseList",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 易宝通订单Copy相关 ====================
// 易宝通订单Copy-列表查询
export function getYbtPayOrderCopyList(data) {
  return request({
    url: "/ybt-pay-order-copy/getYbtPayOrderCopyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 易宝通订单Copy-详情查询
export function getYbtPayOrderCopyDetails(data) {
  return request({
    url: "/ybt-pay-order-copy/getYbtPayOrderCopyDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 易宝通订单Copy-运营描述
export function updatYbtPayOrderCopyHandlerOperation(data) {
  return request({
    url: "/ybt-pay-order-copy/updatYbtPayOrderCopyHandlerOperation",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 易宝通订单Copy-导出excel
export function exportYbtPayOrderCopy(data) {
  return request({
    url: "/ybt-pay-order-copy/exportYbtPayOrderCopy",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 商户其他信息（商户介绍） ====================
// 商户其他信息-获取详情
export function getAjefShopExpandDetails(data) {
  return request({
    url: "/ajef-shop-expand/getAjefShopExpandDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户其他信息-编辑商户介绍
export function updateAjefShopExpandIntroduce(data) {
  return request({
    url: "/ajef-shop-expand/updateAjefShopExpandIntroduce",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 移动纠错订单 ====================
// 移动纠错订单-列表查询
export function getAjefRightsFundWrongReplaceList(data) {
  return request({
    url: "/ajef-rights-fund-wrong-replace/getAjefRightsFundWrongReplaceList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 移动纠错订单-执行更新状态
export function updateAjefRightsFundWrongReplaceSync(data) {
  return request({
    url: "/ajef-rights-fund-wrong-replace/updateAjefRightsFundWrongReplaceSync",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 移动纠错订单-更新扣减SKU
export function updateAjefRightsFundWrongReplaceSku(data) {
  return request({
    url: "/ajef-rights-fund-wrong-replace/updateAjefRightsFundWrongReplaceSku",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 移动纠错订单-执行
export function updateAjefRightsFundWrongReplaceAction(data) {
  return request({
    url: "/ajef-rights-fund-wrong-replace/updateAjefRightsFundWrongReplaceAction",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 可领取八五折券手机号-列表查询
export function getAjefPhoneEightFiveList(data) {
  return request({
    url: "/ajef-phone-eight-five/getAjefPhoneEightFiveList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 可领取八五折券手机号-新增
export function addAjefPhoneEightFive(data) {
  return request({
    url: "/ajef-phone-eight-five/addAjefPhoneEightFive",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 可领取八五折券手机号-编辑
export function updateAjefPhoneEightFive(data) {
  return request({
    url: "/ajef-phone-eight-five/updateAjefPhoneEightFive",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 可领取八五折券手机号-删除（支持批量）
export function deleteAjefPhoneEightFive(data) {
  return request({
    url: "/ajef-phone-eight-five/deleteAjefPhoneEightFive",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 可领取八五折券手机号-批量导入
export function uploadAjefPhoneEightFive(data) {
  return request({
    url: "/ajef-phone-eight-five/uploadAjefPhoneEightFive",
    method: "POST",
    data,
  });
}
// ==================== 微信特约商户进件 ====================
// 进件单-列表
export function getWxApplymentList(data) {
  return request({
    url: "/wx-applyment/getWxApplymentList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 进件单-生成进件单(从商户列表取,asIds逗号分隔)
export function addWxApplyment(data) {
  return request({
    url: "/wx-applyment/addWxApplyment",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 进件单-补录资料Excel批量导入(FormData)
export function importWxApplymentExcel(data) {
  return request({
    url: "/wx-applyment/importWxApplymentExcel",
    method: "POST",
    data,
  });
}
// 进件单-修改补录字段(JSONbody)
export function updateWxApplyment(data) {
  return request({
    url: "/wx-applyment/updateWxApplyment",
    method: "POST",
    data,
  });
}
// 进件单-批量提交(waIds逗号分隔,空为提交全部可提交)
export function submitWxApplymentBatch(data) {
  return request({
    url: "/wx-applyment/submitWxApplymentBatch",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 进件单-详情
export function getWxApplymentDetail(data) {
  return request({
    url: "/wx-applyment/getWxApplymentDetail",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 进件单-状态查询(调微信并回写)
export function getWxApplymentCheck(data) {
  return request({
    url: "/wx-applyment/getWxApplymentCheck",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 微信单品券-商品SKU ====================
// 商品-列表
export function getAjefGoodsList(data) {
  return request({
    url: "/ajef-goods/getAjefGoodsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商品-新增
export function addAjefGoods(data) {
  return request({
    url: "/ajef-goods/addAjefGoods",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商品-编辑
export function updateAjefGoods(data) {
  return request({
    url: "/ajef-goods/updateAjefGoods",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商品-上下架
export function updateAjefGoodsStatus(data) {
  return request({
    url: "/ajef-goods/updateAjefGoodsStatus",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商品-删除(有绑定拦截)
export function deleteAjefGoods(data) {
  return request({
    url: "/ajef-goods/deleteAjefGoods",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 微信单品券-商品子商户绑定 ====================
// 绑定-列表(带商品/商户名称和批次号)
// 绑定-新增(createStock=2同时创建微信批次)
// 绑定-上下架
// 绑定-解绑

// ==================== 微信单品券-批次管理 ====================
// 批次-列表
export function getWxCouponStockList(data) {
  return request({
    url: "/wx-coupon-stock/getWxCouponStockList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批次-创建
export function createWxCouponStock(data) {
  return request({
    url: "/wx-coupon-stock/createWxCouponStock",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批次-激活(预充值须营销账户余额充足)
export function startWxCouponStock(data) {
  return request({
    url: "/wx-coupon-stock/startWxCouponStock",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批次-暂停
export function pauseWxCouponStock(data) {
  return request({
    url: "/wx-coupon-stock/pauseWxCouponStock",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批次-重启
export function restartWxCouponStock(data) {
  return request({
    url: "/wx-coupon-stock/restartWxCouponStock",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批次-同步微信状态
export function getWxCouponStockCheck(data) {
  return request({
    url: "/wx-coupon-stock/getWxCouponStockCheck",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 微信单品券-兑换订单 ====================
// 订单-列表
export function getAjefGoodsOrderList(data) {
  return request({
    url: "/ajef-goods-order/getAjefGoodsOrderList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 订单-详情
export function getAjefGoodsOrderDetail(data) {
  return request({
    url: "/ajef-goods-order/getAjefGoodsOrderDetail",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 订单-撤销(作废券+退权益金)
export function revokeAjefGoodsOrder(data) {
  return request({
    url: "/ajef-goods-order/revokeAjefGoodsOrder",
    method: "POST",
    data: qs.stringify(data),
  });
}
// ==================== 商城订单 ====================
// 商户订单记录-列表
export function getAjefShopOrderRecordList(data) {
  return request({
    url: "/ajef-shop-order-record/getAjefShopOrderRecordList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单-可绑定易宝通订单列表
export function getYbtPayOrderListForBind(data) {
  return request({
    url: "/ajef-shop-order-record/getYbtPayOrderListForBind",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单-手动绑定易宝通订单并分账
export function bindAjefShopOrderRecord(data) {
  return request({
    url: "/ajef-shop-order-record/bindAjefShopOrderRecord",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户订单分账关联-列表
export function getAjefShopOrderRatioList(data) {
  return request({
    url: "/ajef-shop-order-ratio/getAjefShopOrderRatioList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// ==================== 商户分账覆盖规则(2026-10-09,/ajef-shop-order-commission) ====================
// 每商户每档位一条实得金额(无票种维度),分账解析优先于默认规则;同商户同档重复保存=更新
export function getAjefShopOrderCommissionList(data) {
  return request({
    url: "/ajef-shop-order-commission/getAjefShopOrderCommissionList",
    method: "POST",
    data: qs.stringify(data),
  });
}
export function updateAjefShopOrderCommission(data) {
  return request({
    url: "/ajef-shop-order-commission/updateAjefShopOrderCommission",
    method: "POST",
    data: qs.stringify(data),
  });
}
export function deleteAjefShopOrderCommission(data) {
  return request({
    url: "/ajef-shop-order-commission/deleteAjefShopOrderCommission",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 商城订单-退款申请列表
export function getAjefShopOrderRefundApplyList(data) {
  return request({
    url: "/ajef-shop-order-record/getAjefShopOrderRefundApplyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单-退款申请-审核通过
export function updateAjefShopOrderRefundApplyAdopt(data) {
  return request({
    url: "/ajef-shop-order-record/updateAjefShopOrderRefundApplyAdopt",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单-退款申请-审核拒绝
export function updateAjefShopOrderRefundApplyReject(data) {
  return request({
    url: "/ajef-shop-order-record/updateAjefShopOrderRefundApplyReject",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单-直接退款
export function updateAjefShopOrderRefundDirect(data) {
  return request({
    url: "/ajef-shop-order-record/updateAjefShopOrderRefundDirect",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单-退款-权益金回退重试
export function updateAjefShopOrderRefundRightsFundRetry(data) {
  return request({
    url: "/ajef-shop-order-record/updateAjefShopOrderRefundRightsFundRetry",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单-撤销退款(用户决定不退了:订单恢复已分账,商户账户按退款口径还原;仅权益金未回退成功可撤)
export function updateAjefShopOrderRefundCancelDirect(data) {
  return request({
    url: "/ajef-shop-order-record/updateAjefShopOrderRefundCancelDirect",
    method: "POST",
    data: qs.stringify(data),
  });
}
// ==================== 内部商城配套(2026-09-15) ====================
// 商户订单记录-PC管理员补录:asId必填;带内部商城订单号asorOrderNo时手机号/时间可空(以商城订单为准),
// 不带订单号时asorPhone/asorTime(yyyy-MM-dd HH:mm:ss)必填;分账由定时任务匹配
export function addAjefShopOrderRecordAdmin(data) {
  return request({
    url: "/ajef-shop-order-record/addAjefShopOrderRecordAdmin",
    method: "POST",
    data: qs.stringify(data),
  });
}
// ==================== 券记录未领取-扣减未知挂起(2026-09-12领券审计) ====================
// H5领券时权益金扣减结果未知被挂起(status=8)的券-列表(带扣减记录同步状态与处置建议)
export function getAjefCertificateRecordSubUnknownList(data) {
  return request({
    url: "/ajef-certificate-record-sub/getAjefCertificateRecordSubUnknownList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 挂起券处置(resolveType:1恢复已领取 2回池)
export function updateAjefCertificateRecordSubUnknownResolve(data) {
  return request({
    url: "/ajef-certificate-record-sub/updateAjefCertificateRecordSubUnknownResolve",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 挂起券-单券扣减记录即时刷新(同步表有延迟,处置前按券码重查最新一条)
export function getAjefCertificateRecordSubUnknownRefresh(data) {
  return request({
    url: "/ajef-certificate-record-sub/getAjefCertificateRecordSubUnknownRefresh",
    method: "POST",
    data: qs.stringify(data),
  });
}// ==================== 内部商城-供货商管理(2026-09-15新增,/mall-supplier) ====================
// 供货商列表(筛选:amsName名称/amsStatus状态1正常2禁用)
export function getAjefMallSupplierList(data) {
  return request({
    url: "/mall-supplier/getAjefMallSupplierList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增供货商(amsName/amsAccount必填,amsRemark备注) 返回{amsId,initPassword}-初始密码只返回这一次
export function addAjefMallSupplier(data) {
  return request({
    url: "/mall-supplier/addAjefMallSupplier",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑供货商(amsId/amsName/amsAccount必填,amsRemark备注;不改状态和密码)
export function updateAjefMallSupplier(data) {
  return request({
    url: "/mall-supplier/updateAjefMallSupplier",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 供货商启用/禁用(amsStatus:1正常 2禁用;禁用后其商品不可上架不可购买,已下单照常履约)
export function updateAjefMallSupplierStatus(data) {
  return request({
    url: "/mall-supplier/updateAjefMallSupplierStatus",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 重置供货商密码(amsId) 返回{amsId,newPassword}-新密码只返回这一次
export function resetAjefMallSupplierPassword(data) {
  return request({
    url: "/mall-supplier/resetAjefMallSupplierPassword",
    method: "POST",
    data: qs.stringify(data),
  });
}
// ==================== 内部商城-商品管理(2026-09-15新增,/mall-goods) ====================
// 商品列表(筛选:amgName商品名/amsId供货商/amgStatus状态1待上架2上架3下架)
export function getAjefMallGoodsList(data) {
  return request({
    url: "/mall-goods/getAjefMallGoodsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增商品(amsId/amgName/amgPrice分/amgStock必填;amgPrice仅档位12000/24000/36000/48000) 新建默认待上架
export function addAjefMallGoods(data) {
  return request({
    url: "/mall-goods/addAjefMallGoods",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑商品(amgId/amgName/amgPrice/amgStock必填;不修改供货商归属与状态)
export function updateAjefMallGoods(data) {
  return request({
    url: "/mall-goods/updateAjefMallGoods",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商品上架/下架/待上架(amgStatus:1待上架 2上架 3下架;上架时后端校验供货商须为正常)
export function updateAjefMallGoodsStatus(data) {
  return request({
    url: "/mall-goods/updateAjefMallGoodsStatus",
    method: "POST",
    data: qs.stringify(data),
  });
}
// ==================== 内部商城-商城订单管理(2026-09-15新增,/mall-order) ====================
// 商城订单列表(筛选:orderNo订单号/phone下单手机号/amsId供货商/amoStatus状态1已支付待发货2已发货3已完成5已退款/
// refundStatus退款状态0无1申请中2已退款3已驳回/payTimeStart/payTimeEnd下单时间yyyy-MM-dd HH:mm:ss)
export function getAjefMallOrderList(data) {
  return request({
    url: "/mall-order/getAjefMallOrderList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单详情(amoId) 返回{order:订单信息,record:关联订单记录摘要(匹配/分账状态)}
export function getAjefMallOrderDetails(data) {
  return request({
    url: "/mall-order/getAjefMallOrderDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单退款-审核通过(amoId):权益金回补+已分账回退+库存回补+置已退款;失败订单保持申请中可重试
export function updateAjefMallOrderRefundAdopt(data) {
  return request({
    url: "/mall-order/updateAjefMallOrderRefundAdopt",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单退款-审核驳回(amoId/rejectReason驳回原因必填) 用户可修改原因再次申请
export function updateAjefMallOrderRefundReject(data) {
  return request({
    url: "/mall-order/updateAjefMallOrderRefundReject",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单-发货信息修改(PC兜底纠错,amoId/expressCompany快递公司编码/expressNo运单号):待发货录后即转已发货
export function updateAjefMallOrderExpress(data) {
  return request({
    url: "/mall-order/updateAjefMallOrderExpress",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单-物流轨迹查询(amoId):缓存优先,发货超30天只读缓存;
// 成功返回{expressCompany编码,expressCompanyName名称,expressNo运单号,track快递100原始对象{state,data:[{time,context,ftime}]}}
export function getAjefMallOrderExpress(data) {
  return request({
    url: "/mall-order/getAjefMallOrderExpress",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单-PC修改收货信息(amoId/amaReceiver/amaPhone/amaRegion/amaDetail):
// 后端仅待发货(amo_status=1)且不在退款流程(refund_status=0)可改;只改收货快照,扣减手机号快照不动
export function updateAjefMallOrderAddressAdmin(data) {
  return request({
    url: "/mall-order/updateAjefMallOrderAddressAdmin",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商城订单-导出excel(参数与列表同筛选;返回文件流,不走request拦截器,由调用方处理blob下载)
export function exportAjefMallOrderExcel(data) {
  return axios({
    method: "post",
    url: config.baseURL + "/mall-order/exportAjefMallOrderExcel",
    data: qs.stringify(data),
    timeout: 1200000,
    responseType: "arraybuffer",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      useref: window.localStorage.getItem("Qy_token"),
    },
  });
}

// 商户订单记录-导出excel(参数与列表同筛选;后端游标分批多sheet;返回文件流,由调用方处理blob下载)
export function exportAjefShopOrderRecordExcel(data) {
  return axios({
    method: "post",
    url: config.baseURL + "/ajef-shop-order-record/exportAjefShopOrderRecordExcel",
    data: qs.stringify(data),
    timeout: 1200000,
    responseType: "arraybuffer",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      useref: window.localStorage.getItem("Qy_token"),
    },
  });
}

// ==================== 供货商门户(2026-09-16新增,独立登录态,不进管理后台菜单/角色体系) ====================
// 走独立封装supplierRequest:useref头携带sessionStorage的supplierToken,与管理后台Qy_token隔离
// 供货商登录(account/password) 返回{userAes令牌,amsId,amsName};禁用账号返回"账号已禁用,请联系平台"
export function supplierPortalLogin(data) {
  return supplierRequest({
    url: "/mall-supplier-portal/login",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 供货商-本供货商订单列表(amoStatus可选1待发货2已发货3已完成/currentPage/pageSize)
// 后端已抹掉下单手机号/金额/退款原因,只返回履约必要字段
export function getMallOrderListSupplier(data) {
  return supplierRequest({
    url: "/mall-supplier-portal/getMallOrderListSupplier",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 供货商-录入快递单号(amoId/expressCompany快递公司编码/expressNo运单号>=8位)
// 待发货录后即转已发货;已发货可重录纠错;退款申请中被拦截
export function shipMallOrderSupplier(data) {
  return supplierRequest({
    url: "/mall-supplier-portal/shipMallOrderSupplier",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 供货商-快递公司下拉列表(无参) 返回[{comCode编码,name名称}],编码须从下拉选,不允许手填
export function getExpressCompanyListSupplier() {
  return supplierRequest({
    url: "/mall-supplier-portal/getExpressCompanyListSupplier",
    method: "POST",
    data: qs.stringify({}),
  });
}
// 供货商-单号识别快递公司(expressNo) 返回[{comCode,name}];识别不到时由用户从下拉手选
export function getExpressCompanyByNoSupplier(data) {
  return supplierRequest({
    url: "/mall-supplier-portal/getExpressCompanyByNoSupplier",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 供货商-订单导出excel(与列表同筛选,兼批量发货模板;返回文件流,不走supplierRequest拦截器,
// useref头手动携带supplierToken,由调用方处理blob下载)
export function exportMallOrderExcelSupplier(data) {
  return axios({
    method: "post",
    url: config.baseURL + "/mall-supplier-portal/exportMallOrderExcelSupplier",
    data: qs.stringify(data),
    timeout: 1200000,
    responseType: "arraybuffer",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      useref: sessionStorage.getItem("supplierToken"),
    },
  });
}

// 供货商-批量导入发货(FormData文件;表头同导出excel:订单号/快递公司(编码或名称)/运单号;
// 返回{total,successCount,failCount,rows:[{orderNo,expressNo,success,msg}]})
export function importMallOrderShipSupplier(data) {
  return supplierRequest({
    url: "/mall-supplier-portal/importMallOrderShipSupplier",
    method: "POST",
    data,
  });
}

// ==================== 代理商铺货冻结(2026-10-13,/ajef-agent-stock-freeze) ====================
// 档位配置+冻结记录;可提现余额=账户余额-冻结金额,超出冻结部分可提;支持按件数部分解冻
export function getAjefAgentStockTierList(data) {
  return request({
    url: "/ajef-agent-stock-freeze/getAjefAgentStockTierList",
    method: "POST",
    data: qs.stringify(data),
  });
}
export function updateAjefAgentStockTier(data) {
  return request({
    url: "/ajef-agent-stock-freeze/updateAjefAgentStockTier",
    method: "POST",
    data: qs.stringify(data),
  });
}
export function deleteAjefAgentStockTier(data) {
  return request({
    url: "/ajef-agent-stock-freeze/deleteAjefAgentStockTier",
    method: "POST",
    data: qs.stringify(data),
  });
}
export function getAjefAgentStockFreezeList(data) {
  return request({
    url: "/ajef-agent-stock-freeze/getAjefAgentStockFreezeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户当前余额/冻结/可提现(新增冻结弹窗展示用)
export function getAjefAgentStockShopAccount(data) {
  return request({
    url: "/ajef-agent-stock-freeze/getAjefAgentStockShopAccount",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增冻结:items=[{aastId:1,aasfCount:2}]JSON字符串
export function addAjefAgentStockFreeze(data) {
  return request({
    url: "/ajef-agent-stock-freeze/addAjefAgentStockFreeze",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 解冻:count空或0=全部解冻
export function unfreezeAjefAgentStockFreeze(data) {
  return request({
    url: "/ajef-agent-stock-freeze/unfreezeAjefAgentStockFreeze",
    method: "POST",
    data: qs.stringify(data),
  });
}
